export default __webpack_public_path__ + "static/media/radarIcon.14a99072.svg";